export const tabConfig = {
  standard: {
    value: 'standard',
    label: 'Standardrippe',
  },
  lintel: {
    value: 'lintel',
    label: 'Fenstersturz',
  },
  topChord: {
    value: 'top-chord',
    label: 'Rähm',
  },
  bottomChord: {
    value: 'bottom-chord',
    label: 'Schwelle',
  },
}
